import { espalharNaCompetencia, nomeDoMes } from "@bookdental/schemas";
import { reais } from "@/lib/dinheiro";
import { campo, rotulo } from "../estilos";

/** IPTU, seguro, anuidade: o resultado de cada mês leva uma parte; o caixa continua um pagamento só. */
export function DividirCompetencia({ meses, onChange, valorCents, competencia }: { meses: number; onChange: (n: number) => void; valorCents: number; competencia: string }) {
  const partes = espalharNaCompetencia(valorCents, competencia, meses);
  return (
    <label className="block sm:col-span-12">
      <span className={rotulo}>Dividir no resultado</span>
      <select value={meses} onChange={(e) => onChange(Number(e.target.value))} className={campo}>
        <option value={1}>Não: conta toda no mês de competência</option>
        {Array.from({ length: 11 }, (_, i) => i + 2).map((n) => (
          <option key={n} value={n}>
            Em {n} meses
          </option>
        ))}
      </select>
      {meses > 1 && competencia && (
        <span className="mt-1 block text-[11px] text-zinc-500 dark:text-muted-foreground">
          {valorCents > 0 ? `${reais(partes[0]!.valorCents)} por mês` : "Uma parte por mês"}, de {nomeDoMes(competencia)} a {nomeDoMes(partes[partes.length - 1]!.competencia)}. O pagamento continua um só.
        </span>
      )}
    </label>
  );
}
